const KeyboardArrowDownIcon = ({ className }: { className?: string }) => (
	<svg
		class={className}
		fill='currentColor'
		height='4'
		viewBox='0 0 9 4'
		width='9'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path d='M4.25049 4L0.250488 0H8.25049L4.25049 4Z' fill='currentColor' />
	</svg>
)

export { KeyboardArrowDownIcon }
